<template>
    <div>
        <card-header :title="typeLabel" subheader="Contacts" :icon="typeIcon"/>

        <card-body>
            <card-toolbar>
                <button @click="$openCard('new-directory-contact', {type: props.type}, card)"><i class="fas fa-plus mr-2"/>New Contact</button>
            </card-toolbar>
            <card-list>
                <!-- Companies first: one row each, the people behind a card
                     to the right. -->
                <subheader-list-item title="Companies" icon="fa-building" :badge="companies.length"/>
                <navigation-list-item
                    v-for="co in companies"
                    :key="co.company"
                    icon="fa-building"
                    :title="co.company"
                    :subtitle="companySubtitle(co)"
                    :badge="co.contact_count"
                    :active="child && child.definition.component === 'contact-company' && child.props.companyKey === companyKey(co.company)"
                    @click="$openCard('contact-company', {type: props.type, companyKey: companyKey(co.company)}, card)"
                />
                <container-list-item padded v-if="!companies.length">
                    <p class="has-text-grey is-size-7 my-2">No companies yet.</p>
                </container-list-item>

                <!-- Then the contacts filed under no company at all: a guide
                     or driver who is just a person. Straight to the contact. -->
                <subheader-list-item title="Individuals" icon="fa-user" :badge="individuals.length" v-if="individuals.length"/>
                <contact-list-item
                    :card="card"
                    :contact="c"
                    v-for="c in individuals"
                    :key="c.id"
                    :active="child && child.definition.component === 'contact' && String(child.props.contactId) === String(c.id)"
                    @click="$openCard('contact', {contactId: c.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import ContactListItem from "@/components/ContactListItem";
    import {client as http} from "@/http_client";
    import {typeLabel, typeIcon, companyKey} from "@/components/contact_meta";

    /**
     * One type of the directory: its companies, and the contacts that have
     * no company. The middle level of Contacts -> type -> company -> contact.
     */
    export default {
        name: "ContactType",
        props: ['card', 'child', 'props'],
        components: {
            ContactListItem, NavigationListItem, ContainerListItem, SubheaderListItem,
            CardToolbar, CardBody, CardList, CardHeader
        },
        data: function () {
            return {
                companies: [],
                individuals: []
            };
        },
        computed: {
            typeLabel: function () {
                return typeLabel(this.props.type);
            },
            typeIcon: function () {
                return typeIcon(this.props.type);
            }
        },
        methods: {
            companyKey,
            load(force) {
                // The breadcrumb reads the type, not "Contact Type".
                this.$emit('title', this.typeLabel);
                this.$emit('loading', true);
                const type = encodeURIComponent(this.props.type);
                Promise.all([
                    http.get('/api/contacts/companies?type=' + type, {force}),
                    http.get('/api/contacts?type=' + type + '&company=', {force})
                ]).then(([companies, individuals]) => {
                    this.companies = companies.data || [];
                    this.individuals = individuals.data || [];
                    this.$emit('loading', false);
                });
            },
            companySubtitle(co) {
                return [co.city, co.country].filter(Boolean).join(', ');
            },
            reload: function () {
                this.load(true);
            }
        },
        watch: {
            'props.type': function () {
                this.load(true);
            },
            // TIER rebuilds its card objects (title and all) on every route
            // change, so the breadcrumb forgets the title whenever a child
            // opens. Re-say it.
            card: function () {
                this.$emit('title', this.typeLabel);
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
